<template>
    <el-row class="mb-1">

        <el-col>
               <div style="width: auto;height: 400px" id="main"></div>
        </el-col>
    </el-row>
</template>
<script>
  import * as echarts from 'echarts';
  export default {
    name: "echarts",
    data() {
      return {}
    },
    mounted() {
      this.echartsInit()
    },
    methods:{
      echartsInit() {　　　　　//使用时只需要把setOption里的对象换成echarts中的options或者自己的参数即可
        echarts.init(document.getElementById('main')).setOption({
          xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(220, 220, 220, 0.8)'
            }
          }]
        })
      }
    }
  }
</script>